<template>
    <div
        ref="wrap"
        class="depth-map-wrap"
        :class="isFullScreenStatus ? 'full-wrap' : 'unFull-wrap'"
    >
        <div class="wrap-canvas">
            <canvas
                id="depth"
                ref="depth"
                :width="`${canvasWidth}px`"
                :height="`${canvasHeight}px`"
            />
        </div>
        <canvas
            id="x"
            ref="xAxis"
            :width="`${canvasWidth + yAxisWidth}px`"
            height="24"
        />
        <canvas
            id="y"
            ref="yAxis"
            :width="yAxisWidth"
            :height="`${canvasHeight}px`"
        />
        <canvas
            id="point"
            ref="point"
            :width="`${canvasWidth}px`"
            :height="`${boxWrapHeight}px`"
        />
    </div>
</template>

<script>
import { transNumOtherUnit } from '@/utils/index';
export default {
    name: 'DepthMap',
    props: {
        depthFiveBuyData: {
            type: Array,
            default() {
                return [];
            }
        },
        depthFiveSaleData: {
            type: Array,
            default() {
                return [];
            }
        },
        fullscreen: {
            type: Boolean,
            default: false
        },
        // 交易对
        currentCurrency: {
            type: String
        }
    },
    data() {
        return {
            showWrap: true,
            filterFiveBuyList: [],
            filterFiveSaleList: [],
            canvasWidth: '',
            canvasHeight: 500, // 画布的高度
            boxWrapHeight: 0, // 容器的高度
            maxAmount: 0,
            yAxisWidth: 50,
            buyPointList: [],
            salePointList: [],
            lastSalePoint: {}, // 上一次卖方的触摸坐标
            lastBuyPoint: {}, //  上一次买方的触摸坐标
            curClienX: -1, // 当前触摸的坐标，解决鼠标不懂，数据发生变化位置没变的问题, 小于0用于处理数据发生变化一直调用问题
            pointCanvas: null, // tooltip 的画布
            // canvas 配置
            options: {
                gap: 10,
                showMidLine: true,
                midLineOption: {
                    width: 1,
                    color: 'rgba(213,213,213,0.2)'
                },
                buyOptions: {
                    pointColor: '#27B485', // 点的颜色
                    valueColor: '#27B485', // 幅度差value颜色值
                    stokeLineColor: 'rgba(39,180,133,1)', // 线的颜色
                    fillColor: 'rgba(39,180,133, 0.04)', // 填充的颜色
                    moveBgColor: 'rgba(39,180,133, 0.05)' // 覆盖的颜色
                },
                saleOptions: {
                    pointColor: '#D4575C',
                    valueColor: '#D4575C',
                    stokeLineColor: 'rgba(212,87,92,1)',
                    fillColor: 'rgba(212,87,92,0.04)',
                    moveBgColor: 'rgba(212,87,92,0.05)'
                }
            },
            isOnRenderToolTips: false, // 数据更新一直渲染重复
            canvasMaxHeight: 0, // canvas最大高度，初始化为容器的80%
            yAxisSplitNum: 5, // y轴到数据最大值有多少刻度， 不包含最大值以上的
            xAxisSplitNum: 5,
            curShowDataNum: 14, // 默认每方只展示12条，可通过滚轮放大缩小
            fullscreenStyle: {},
            isFullScreenStatus: false,
            dotNum: -1, // 数据的显示小数位（y轴）
            xAxisDotNum: -1, // x轴小数位
            originWrapWidth: 0, // 初次加载的容器宽度，用来做放大缩小，切换版本的显示
            originWrapHeight: 0 // 初次加载的容器高度
        };
    },
    watch: {
        currentCurrency: {
            handler() {
                this.xAxisDotNum = -1;
                this.dotNum = -1;
                this.handleCleanDepthCanvas();
            }
        },
        fullscreen: {
            handler(nVal) {
                if (nVal) {
                    // 解决页面闪白屏
                    document.documentElement.style.backgroundColor = '#000';
                    this.isFullScreenStatus = true;
                    document.documentElement.requestFullscreen();
                    this.handleFullOrNotFullScreen(true);
                }
            }
        },
        depthFiveBuyData: {
            handler(nVal) {
                if (nVal.length > 0) {
                    this.handleDataDot(nVal);
                    this.filterFiveBuyList = this.handleData(nVal);
                    this.initDepthMap();
                    if (this.curClienX > 0 && !this.isOnRenderToolTips) {
                        this.handleShowToolTips(this.curClienX);
                    }
                }
            },
            deep: true
        },
        depthFiveSaleData: {
            handler(nVal) {
                if (nVal.length > 0) {
                    this.handleDataDot(nVal);
                    this.filterFiveSaleList = this.handleData(nVal, 'sale');
                    this.initDepthMap();
                    if (this.curClienX > 0 && !this.isOnRenderToolTips) {
                        this.handleShowToolTips(this.curClienX);
                    }
                }
            },
            deep: true
        }
    },
    mounted() {
        const that = this;
        const trapBox = this.$refs['wrap'];
        this.canvasWidth = trapBox.offsetWidth - this.yAxisWidth;
        this.canvasMaxHeight = this.canvasHeight * 0.8;
        this.originWrapWidth = trapBox.offsetWidth;
        this.originWrapHeight = trapBox.offsetHeight;

        this.boxWrapHeight = trapBox.offsetHeight;
        this.pointCanvas = this.$refs['point'];
        this.pointCanvas.onmousemove = e => {
            that.handleShowToolTips(e.offsetX);
        };
        this.pointCanvas.onmouseleave = e => {
            that.handleHiddenToolTips();
        };
        this.pointCanvas.onmousewheel = e => {
            that.handleMouseWheel(e);
            e.preventDefault();
        };
        document.onfullscreenchange = e => {
            if (!document.fullscreenElement) {
                // console.log("页面已退出全屏状态");
                that.isFullScreenStatus = false;
                that.$nextTick(() => {
                    that.handleFullOrNotFullScreen(false);
                });
            } else {
                that.$nextTick(() => {
                    that.resetRender();
                });
            }
        };
    },
    methods: {
        // 处理全屏事件
        handleFullOrNotFullScreen(isFull = false) {
            if (document.fullscreenElement || isFull) {
                this.canvasWidth = window.screen.width - this.yAxisWidth;
                this.canvasHeight = window.screen.height - 50;
                this.boxWrapHeight = window.screen.height;
                this.canvasMaxHeight = this.canvasHeight * 0.8;
            } else {
                this.$emit('changeStatus', false);
                this.canvasHeight = 500;
                this.canvasWidth = this.originWrapWidth - this.yAxisWidth;
                this.canvasMaxHeight = this.canvasHeight * 0.8;
                this.boxWrapHeight = this.originWrapHeight;
                this.$nextTick(() => {
                    this.resetRender();
                });
            }
        },
        // 重新回执
        resetRender() {
            if (
                this.depthFiveBuyData.length == 0 ||
                this.depthFiveSaleData.length == 0
            )
                return;
            this.filterFiveBuyList = this.handleData(this.depthFiveBuyData);
            this.filterFiveSaleList = this.handleData(
                this.depthFiveSaleData,
                'sale'
            );
            this.rendYAxis();
            this.rendXAxis();
            this.initDepthMap();
            this.handleShowToolTips(this.curClienX);
        },
        // 处理滚轮事件
        handleMouseWheel(e) {
            // 滚动是否向下， 向下表示缩小数据（增加数据零）， 向上表示放大数据（减少数据量）
            const isDown = e.deltaY > 0;
            if (isDown) {
                if (this.yAxisSplitNum == 8) return;
                this.yAxisSplitNum += 1;
                this.curShowDataNum += 2;
            } else {
                if (this.yAxisSplitNum == 4) return;
                this.yAxisSplitNum -= 1;
                this.curShowDataNum -= 2;
            }
            this.resetRender();
        },
        renderPoint(x, y, ctx, type = 'buy') {
            const { buyOptions, saleOptions } = this.options;
            ctx.beginPath();
            ctx.arc(x, y, 4, 0, 2 * Math.PI);
            ctx.fillStyle =
                type == 'buy' ? buyOptions.pointColor : saleOptions.pointColor;
            ctx.fill();
            ctx.closePath();
        },
        // 内容显示
        renderToolTips(x, y, index, ctx, type = 'buy') {
            const rectHeight = 76;
            const rectWidth = 120;
            const rectGap = 10;
            const allRect = rectWidth + rectGap;
            let renderRectX;
            const leftValueGap = 50;
            const rightValueGap = 70;
            const heightGap = 20;
            // 左右显示
            const list =
                type == 'buy'
                    ? this.filterFiveBuyList
                    : this.filterFiveSaleList;
            const labelPos = [];
            let pricePos = {};
            const valuePos = [];
            const labelWord = [
                this.$t('message.comC.priceRange'),
                this.$t('message.spot.entrustedPrice'),
                this.$t('message.comC.cumulativeOrders')
            ];
            if (
                (x - this.canvasWidth / 2 >= rectWidth + 10 && type != 'buy') ||
                (type == 'buy' && this.canvasWidth / 2 - x <= rectWidth + 10)
            ) {
                renderRectX = x - allRect;
                labelWord.forEach((item, index) => {
                    labelPos.push({
                        text: item,
                        x: x - rectWidth,
                        y: y - rectHeight / 2 + (index + 1) * 20
                    });
                });
                pricePos = {
                    text: (list[index][2] * 100).toFixed(2) + '%',
                    x: x - rectWidth + leftValueGap,
                    y: y - rectHeight / 2 + heightGap
                };
                valuePos.push({
                    text: transNumOtherUnit(
                        Number(list[index][0]),
                        this.xAxisDotNum
                    ),
                    x: x - rectWidth + leftValueGap,
                    y: y - rectHeight / 2 + heightGap * 2
                });
                valuePos.push({
                    text: transNumOtherUnit(
                        Number(list[index][1]),
                        this.dotNum
                    ),
                    x: x - rectWidth + leftValueGap,
                    y: y - rectHeight / 2 + heightGap * 3
                });
            }
            if (
                (x - this.canvasWidth / 2 < rectWidth + 10 && type != 'buy') ||
                (type == 'buy' && this.canvasWidth / 2 - x > rectWidth + 10)
            ) {
                renderRectX = x + 10;
                labelWord.forEach((item, index) => {
                    labelPos.push({
                        text: item,
                        x: x + 20,
                        y: y - rectHeight / 2 + (index + 1) * 20
                    });
                });
                pricePos = {
                    text: (list[index][2] * 100).toFixed(2) + '%',
                    x: x + rightValueGap,
                    y: y - rectHeight / 2 + heightGap
                };
                valuePos.push({
                    text: transNumOtherUnit(
                        Number(list[index][0]),
                        this.xAxisDotNum
                    ),
                    x: x + rightValueGap,
                    y: y - rectHeight / 2 + heightGap * 2
                });
                valuePos.push({
                    text: transNumOtherUnit(Number(list[index][1])),
                    x: x + rightValueGap,
                    y: y - rectHeight / 2 + heightGap * 3
                });
            }

            ctx.beginPath();
            ctx.font = '11px PingFang_Regular';
            ctx.rect(renderRectX, y - rectHeight / 2, rectWidth, rectHeight);
            ctx.fillStyle = '#2B3139';
            ctx.fill();
            ctx.fillStyle = '#90959C ';
            if (labelPos.length > 0) {
                labelPos.forEach(v => {
                    ctx.fillText(v.text, v.x, v.y);
                });
            }
            const { buyOptions, saleOptions } = this.options;
            ctx.fillStyle =
                type == 'buy' ? buyOptions.valueColor : saleOptions.valueColor;
            ctx.fillText(pricePos.text, pricePos.x, pricePos.y);
            ctx.fillStyle = '#fff';
            valuePos.forEach(v => {
                ctx.fillText(v.text, v.x, v.y);
            });
            ctx.closePath();
        },
        renderLine(x, ctx) {
            ctx.lineWidth = 1;
            ctx.strokeStyle = 'white';
            ctx.beginPath();
            ctx.setLineDash([3, 2]);
            ctx.moveTo(x, 0);
            ctx.lineTo(x, this.canvasHeight);
            ctx.stroke();
            ctx.closePath();
        },
        // 渲染阴影
        renderAeaTool(x, ctx, type = 'buy') {
            const { buyOptions, saleOptions } = this.options;
            ctx.beginPath();
            ctx.moveTo(x, this.canvasHeight);
            if (type == 'buy') {
                ctx.fillStyle = buyOptions.moveBgColor;
                ctx.lineTo(0, this.canvasHeight);
                ctx.lineTo(0, 0);
                ctx.lineTo(x, 0);
                ctx.lineTo(x, this.canvasHeight);
            } else {
                ctx.fillStyle = saleOptions.moveBgColor;
                ctx.lineTo(this.canvasWidth, this.canvasHeight);
                ctx.lineTo(this.canvasWidth, 0);
                ctx.lineTo(x, 0);
                ctx.lineTo(x, this.canvasHeight);
            }
            ctx.fill();
            ctx.closePath();
        },
        handleHiddenToolTips() {
            const ctx = this.pointCanvas.getContext('2d');
            ctx.clearRect(0, 0, this.canvasWidth, this.boxWrapHeight);
            this.curClienX = -1;
        },
        // 显示tooltips
        handleShowToolTips(elementX) {
            if (
                this.depthFiveBuyData.length == 0 ||
                this.depthFiveSaleData.length == 0
            )
                return;
            this.isOnRenderToolTips = true;
            this.curClienX = elementX;
            // 显示右边
            let numX, gapRight, index;
            if (elementX > this.canvasWidth / 2) {
                numX = elementX - this.canvasWidth / 2;
                gapRight =
                    this.canvasWidth / 2 / this.filterFiveSaleList.length;
                index = Math.round(numX / gapRight);
            } else {
                numX = this.canvasWidth / 2 - elementX;
                gapRight = this.canvasWidth / 2 / this.filterFiveBuyList.length;
            }
            index = Math.round(numX / gapRight);
            if (index >= this.filterFiveSaleList.length) return;
            const ctx = this.pointCanvas.getContext('2d');
            ctx.clearRect(0, 0, this.canvasWidth, this.boxWrapHeight);
            // 卖方
            const { x: saleX, y: saleY } = this.salePointList[index];
            this.renderLine(saleX, ctx);
            this.renderPoint(saleX, saleY, ctx, 'sale');
            this.renderAeaTool(saleX, ctx, 'sale');
            this.renderToolTips(saleX, saleY, index, ctx, 'sale');
            // 买方
            const { x: buyX, y: buyY } = this.buyPointList[index];
            this.renderLine(buyX, ctx);
            this.renderPoint(buyX, buyY, ctx);
            this.renderAeaTool(buyX, ctx);
            this.renderToolTips(buyX, buyY, index, ctx, 'buy');
            this.isOnRenderToolTips = false;
        },
        // 处理渲染的节点
        handlePointList() {
            const maxAmount = Math.max(
                this.filterFiveBuyList[this.filterFiveBuyList.length - 1][1],
                this.filterFiveSaleList[this.filterFiveSaleList.length - 1][1]
            );
            this.maxAmount = maxAmount;
            const { width } = this.$refs['depth'];
            const height = this.canvasMaxHeight;
            const scaleW = width / 2 / this.filterFiveBuyList.length;
            const gap = this.options.gap;
            this.buyPointList = [];
            this.salePointList = [];
            for (const i in this.filterFiveBuyList) {
                const x = width / 2 - i * scaleW - gap;
                const y =
                    this.canvasHeight -
                    (this.filterFiveBuyList[i][1] / maxAmount) * height;
                this.buyPointList.push({ x, y });
            }
            for (const i in this.filterFiveSaleList) {
                const x = width / 2 + i * scaleW + gap;
                const y =
                    this.canvasHeight -
                    (this.filterFiveSaleList[i][1] / maxAmount) * height;
                this.salePointList.push({ x, y });
            }
        },
        handleCleanDepthCanvas() {
            const canvas = this.$refs['depth'];
            const context = canvas.getContext('2d');
            context.clearRect(0, 0, canvas.width, canvas.height);
            let contextX = this.$refs['xAxis'].getContext('2d');
            contextX.clearRect(0, 0, this.canvasWidth, 24);
            let contextY = this.$refs['yAxis'].getContext('2d');
            const { width, height } = this.$refs['yAxis'];
            contextY.clearRect(0, 0, width, height);
        },
        // 渲染画布
        initDepthMap() {
            const { buyOptions, saleOptions, showMidLine, midLineOption } =
                this.options;
            if (
                this.filterFiveBuyList.length > 0 &&
                this.filterFiveSaleList.length > 0
            ) {
                this.handlePointList();
                // X轴偏移量 防止左右两部分连接以利于美观
                const gap = this.options.gap;
                // 开始画布
                const canvas = this.$refs['depth'];
                const width = canvas.width;
                const height = canvas.height;
                const context = canvas.getContext('2d');
                context.clearRect(0, 0, width, height);

                // 画中间线
                if (showMidLine) {
                    context.beginPath();
                    context.fillStyle = midLineOption.color;
                    context.fillRect(width / 2, 0, midLineOption.width, height);
                    context.closePath();
                }

                // 买方深度图
                context.fillStyle = buyOptions.fillColor;
                context.beginPath();
                context.moveTo(width / 2 - gap, height);
                for (const i of this.buyPointList) {
                    context.lineTo(i.x, i.y);
                }
                context.lineTo(
                    0,
                    this.buyPointList[this.buyPointList.length - 1].y
                ); // 延伸到最左侧边缘
                context.strokeStyle = buyOptions.stokeLineColor;
                context.stroke();
                context.lineTo(0, height);
                context.fill();
                context.closePath();

                // 开始绘制卖单深度图
                context.beginPath();
                context.fillStyle = saleOptions.fillColor;
                context.moveTo(width / 2 + gap, height);
                for (const i of this.salePointList) {
                    context.lineTo(i.x, i.y);
                }
                context.lineTo(
                    width + gap,
                    this.salePointList[this.salePointList.length - 1].y
                );
                context.strokeStyle = saleOptions.stokeLineColor;
                context.stroke();
                context.lineTo(width + gap, height);
                context.fill();
                context.closePath();

                // X轴刻度
                this.rendXAxis();

                // Y轴刻度
                this.rendYAxis();
            }
        },

        // 渲染x轴
        rendXAxis() {
            let contextX = this.$refs['xAxis'].getContext('2d');
            contextX.clearRect(0, 0, this.canvasWidth + this.yAxisWidth, 24);
            contextX.fillStyle = '#fff';
            const dataMap = {
                buy: this.filterFiveBuyList,
                sale: this.filterFiveSaleList
            };
            const y = 15;
            let x;
            const width = this.canvasWidth;
            const maxBuyData = Number(dataMap['buy'][0][0]);
            const maxSaleData = Number(
                dataMap['sale'][dataMap['sale'].length - 1][0]
            );
            const minBuyData = Number(
                dataMap['buy'][dataMap['buy'].length - 1][0]
            );
            const minSaleData = Number(dataMap['sale'][0][0]);
            const valueBuyGap = maxBuyData - minBuyData;
            const valueSaleGap = maxSaleData - minSaleData;
            const scaleW = width / 2 / this.xAxisSplitNum;
            const resValue = (key, i) => {
                let gap, value;
                if (key == 'buy') {
                    gap = valueBuyGap / this.xAxisSplitNum;
                    value = maxBuyData - gap * i;
                } else {
                    gap = valueSaleGap / this.xAxisSplitNum;
                    value = minSaleData + gap * i;
                }
                return value.toFixed(
                    this.xAxisDotNum < 0 ? 0 : this.xAxisDotNum
                );
            };
            for (const key in dataMap) {
                for (let j = 0; j < this.xAxisSplitNum; j++) {
                    x = j * scaleW;
                    const value = resValue(key, j);
                    const reviseX =
                        key == 'buy' ? width / 2 - x - 60 : x + width / 2 + 40;
                    contextX.lineWidth = 2;
                    contextX.beginPath();
                    contextX.rect(reviseX + 10, 0, 1, 4);
                    contextX.fillStyle = '#fff';
                    contextX.fill();
                    contextX.closePath();
                    contextX.fillText(value, reviseX, y);
                }
            }
        },
        rendYAxis() {
            let contextY = this.$refs['yAxis'].getContext('2d');
            const { width, height } = this.$refs['yAxis'];
            contextY.clearRect(0, 0, width, height);
            contextY.fillStyle = '#fff';
            const splitNum = this.yAxisSplitNum;
            let seg = this.maxAmount / splitNum;
            const x = 5;
            let y;
            const lastCanvasHeight = this.canvasHeight - this.canvasMaxHeight;
            const setHeight =
                ((seg * 1) / this.maxAmount) * this.canvasMaxHeight;
            const num = Math.ceil(lastCanvasHeight / setHeight);
            for (let i = 1; i <= splitNum + num; i++) {
                y =
                    this.canvasHeight -
                    ((seg * i) / this.maxAmount) * this.canvasMaxHeight;
                contextY.beginPath();
                contextY.fillStyle = '#d5d5d5';
                contextY.fillRect(0, y - 4, 4, 1);
                contextY.closePath();
                contextY.fillText(
                    transNumOtherUnit(seg * i, this.dotNum),
                    x,
                    y
                );
            }
        },

        // 获取数据小数点
        handleDataDot(list) {
            const getNum = data => {
                let num = 0;
                const arr =
                    typeof data == 'number'
                        ? data.toString().split('.')
                        : data.split('.');
                if (arr.length == 2) {
                    num = arr[1].toString().length;
                }
                return num;
            };
            if (this.xAxisDotNum < 0) {
                const XData = list[0][0];
                this.xAxisDotNum = getNum(XData);
            }
            if (this.dotNum < 0) {
                const data = list[0][1];
                this.dotNum = getNum(data);
            }
        },
        // 处理数据
        handleData(list, type = 'buy') {
            const newList = JSON.parse(JSON.stringify(list));
            let parseList = this.handleSortArr(newList, type);
            parseList = this.handleSplitData(parseList);
            const minNum = Number(parseList[0][0]);
            const arr = [];
            parseList.forEach((item, index) => {
                let x = 0;
                let y = 0;
                x = item[0];
                if (index >= 1) {
                    y = Number(arr[index - 1][1]) + Number(item[1]);
                } else {
                    y = Number(item[1]);
                }
                const rate =
                    type == 'buy'
                        ? (minNum - x) / minNum
                        : (x - minNum) / minNum;
                arr.push([x, y.toFixed(this.dotNum), rate]);
            });
            return arr;
        },
        handleSplitData(list) {
            const dataArr = list.slice(0, this.curShowDataNum);
            return dataArr;
        },
        handleSortArr(list, type = 'buy') {
            function sortNumberSub(a, b) {
                return Number(b[0]) - Number(a[0]);
            }
            function sortNumberAsc(a, b) {
                return Number(a[0]) - Number(b[0]);
            }
            type == 'buy' ? list.sort(sortNumberSub) : list.sort(sortNumberAsc);
            return list;
        }
    }
};
</script>

<style lang="scss" scoped>
.depth-map-wrap {
    position: relative;
}

#y {
    position: absolute;
    top: 0px;
    right: 0;
}

#point {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
}

.unFull-wrap {
    height: 540px;
}

.full-wrap {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: 9999 !important;
    height: 100vh !important;
    background-color: #000;
}
</style>
